import React from 'react';
import PopPop from 'react-poppop';
import ClipLoader from 'react-spinners/ClipLoader';

const contentStyle = {
	borderRadius: 0,
	maxWidth: '450px',
	padding: '1.5rem 2rem',
};

const LoaderModal = ({ isOpen, onClose }) => {
	return (
		<PopPop
			open={isOpen}
			position="centerCenter"
			closeOnEsc={false}
			closeOnOverlay={false}
			onClose={onClose}
			contentStyle={contentStyle}
		>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<ClipLoader
					sizeUnit={'px'}
					size={25}
					color={'#008CBA'}
					loading={true}
					css={{ marginRight: '10px' }}
				/>
				<div className="right color-secondary">Please wait...</div>
			</div>
		</PopPop>
	);
};

export default LoaderModal;
